// drpdæ · Jade Market — theme behaviors
(function () {
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const formatMoney = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || 'Dhs {{amount}}';
    const f = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney : (c) => 'Dhs ' + (c / 100).toFixed(2);
    return f(cents, fmt).replace(/\$([\d,\.]+)/, 'Dhs $1');
  };

  const drawer = () => $('[data-cart-drawer]');
  function openCart() { const d = drawer(); if (!d) return; if (!d.open) d.showModal(); }
  function closeCart() { const d = drawer(); if (d && d.open) d.close(); }

  async function refreshCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const itemCountEl = $('[data-cart-count]');
    if (itemCountEl) itemCountEl.textContent = cart.item_count;
    $$('[data-cart-total]').forEach(el => { el.textContent = formatMoney(cart.total_price); });
    const subtotalEl = $('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
    const itemsEl = $('[data-cart-items]');
    if (itemsEl) itemsEl.innerHTML = cart.items.length ? cart.items.map(renderItem).join('') : emptyState();
    updateFreeShip(cart.total_price);
    return cart;
  }

  function updateFreeShip(totalCents) {
    const threshold = parseInt($('meta[name="free-ship-threshold"]')?.content || '15000', 10);
    const bar = $('[data-free-ship-fill]');
    const label = $('[data-free-ship-label]');
    const shippingEl = $('[data-cart-shipping]');
    if (bar) bar.style.width = Math.min(100, (totalCents / threshold) * 100) + '%';
    if (label) label.textContent = totalCents >= threshold ? '✺ free shipping unlocked' : 'Dhs ' + ((threshold - totalCents) / 100).toFixed(2) + ' away from free shipping';
    if (shippingEl) shippingEl.textContent = totalCents >= threshold ? '✺ free' : 'AED 25 · free over AED 150';
  }

  function emptyState() { return `<div class="cart-empty"><p class="body">your basket's empty — start with this week's finds.</p></div>`; }

  function renderItem(item) {
    return `<article class="cart-item" data-line-key="${item.key}">
      <div class="cart-item__media"><img src="${item.image}" alt="${escapeHtml(item.product_title)}"></div>
      <div>
        <div class="h4 lowercase" style="font-size:18px;line-height:1.1">${escapeHtml(item.product_title)}</div>
        <div class="body-sm">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : ''}</div>
        <div style="display:flex;align-items:center;gap:8px;margin-top:6px">
          <div class="cart-item__qty"><button data-qty-down>−</button><span>${item.quantity}</span><button data-qty-up>+</button></div>
          <button class="body-sm" data-remove style="background:transparent;border:0;color:var(--mute);text-decoration:underline;cursor:pointer">remove</button>
        </div>
      </div>
      <div class="h4" style="font-family:var(--ff-display);font-weight:700;font-size:18px">${formatMoney(item.line_price)}</div>
    </article>`;
  }

  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener) { e.preventDefault(); openCart(); refreshCart(); return; }
    const closer = e.target.closest('[data-close-cart]');
    if (closer) { e.preventDefault(); closeCart(); return; }
  });

  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[action^="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    const btn = f.querySelector('[type=submit]');
    const original = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = 'adding…'; }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) throw new Error('add failed');
      await refreshCart(); openCart();
    } catch (err) { console.error(err); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = original; } }
  });

  document.addEventListener('click', async (e) => {
    const item = e.target.closest('[data-line-key]');
    if (!item) return;
    const key = item.dataset.lineKey;
    if (e.target.matches('[data-qty-up]') || e.target.matches('[data-qty-down]')) {
      const span = item.querySelector('.cart-item__qty span');
      let q = parseInt(span.textContent, 10) + (e.target.matches('[data-qty-up]') ? 1 : -1);
      if (q < 0) q = 0;
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: q }) });
      await refreshCart();
    } else if (e.target.matches('[data-remove]')) {
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: 0 }) });
      await refreshCart();
    }
  });

  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.variant-pill[data-option-index]');
    if (!pill) return;
    const wrap = pill.closest('[data-product-form]');
    if (!wrap) return;
    const idx = pill.dataset.optionIndex;
    $$(`.variant-pill[data-option-index="${idx}"]`, wrap).forEach(b => b.classList.toggle('is-active', b === pill));
    const selected = $$('.variant-pill.is-active', wrap).map(b => b.dataset.value);
    const variants = JSON.parse(wrap.dataset.variants || '[]');
    const found = variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
    if (found) {
      const idInput = wrap.querySelector('input[name="id"]'); if (idInput) idInput.value = found.id;
      const priceEl = wrap.querySelector('[data-price]'); if (priceEl) priceEl.textContent = formatMoney(found.price);
    }
  });

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const root = tab.closest('[data-tabs]');
    if (!root) return;
    const name = tab.dataset.tab;
    $$('[data-tab]', root).forEach(b => b.classList.toggle('is-active', b === tab));
    $$('[data-tab-panel]', root).forEach(p => p.toggleAttribute('hidden', p.dataset.tabPanel !== name));
  });

  function fixCurrencyDisplay() {
    document.querySelectorAll('.price,.product-card__price,[data-price],[data-cart-total],[data-cart-subtotal],.cart-summary__total span,.cart-summary__row span,.pdp-price .price,.cart-item').forEach(function(el) {
      if (el.children.length === 0) el.textContent = el.textContent.replace(/\$([\d,\.]+)/g, 'Dhs $1');
    });
  }

  document.addEventListener('DOMContentLoaded', () => { refreshCart(); fixCurrencyDisplay(); });

  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.pdp-thumb');
    if (!thumb) return;
    var thumbImg = thumb.querySelector('img'); if (!thumbImg) return;
    var mainImg = document.querySelector('.pdp-gallery__main img'); if (!mainImg) return;
    mainImg.src = thumbImg.src;
    if (thumbImg.srcset) mainImg.srcset = thumbImg.srcset;
    document.querySelectorAll('.pdp-thumb').forEach(function(t) { t.classList.toggle('is-active', t === thumb); });
  });

  window.drpd = { openCart, closeCart, refreshCart };
})();
